import React from 'react';

const ActivationErrorForm = () => {
    return (
        <React.Fragment>
            <h1>Account Activation Error</h1>
            <div>
                <p>
                    We were unable to perform the requested operation to your account.  Please try again later.
                </p>
            </div>
        </React.Fragment>
    )
}

export default ActivationErrorForm;